// 明細編集パネル
<template>

  <div class="cx_voucherItems" :class="{cx_popover:popover}">
        <!-- 左側の明細リスト 追加ボタンを配置-->
        <div class="cx_header" v-if="!popover">
          <div class="caption" ref="title"><span>{{ $translate(title) }}</span></div>
          <div class="menu cx_appevent_enabled"><slot name="menu" :parent="_self"></slot></div>
          <b-pagination size="sm" v-if="params && totalRows > params.perPage" align="right" @change="onPageChange" :total-rows="totalRows" v-model="params.currentPage" :per-page="params.perPage"></b-pagination>          
        </div>
        <!-- タブは上位・下位リンク表示　ポップオーバーは下位リンク表示 -->
        <div v-if="popover==false" class="cx_voucherItems_container">
          <!-- 受注明細 -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesOrderItem" storageKey="v_items_SalesOrderItem" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"            
            :visibles="gridConfig.gridVisibles">              
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesOrderItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.orderItemNo }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">
                  <span class="cx_link_item" @click="showPopover(item.orderItemNo,voucherTypes.SalesDeliveryItem,$event)" :tabindex="-1">出荷</span>
                  <span class="cx_link_item" @click="showPopover(item.orderItemNo,voucherTypes.PurchaseOrderItem,$event)" :tabindex="-1">発注</span>
                  <span class="cx_link_item" @click="showPopover(item.orderItemNo,voucherTypes.PurchaseDeliveryItem,$event)" :tabindex="-1">入荷</span>
                </GridItem>                         
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{item.commodity.model }}</GridItem>                
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }"><BtnStockSchedule :commodity="item.commodity" :sku="item.sku" :segment="item.order.segment"  :stockDate="item.scheduledDeliveryDate"/></GridItem>                
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.backSalesOrderQuantity | numeric(item.commodity.quantityScale) }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.order.currencyCode) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item }">{{ item.commodity.sellingPrice | numeric(item.commodity.stockPriceScale)}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item }">{{ item.purchasePrice | numeric(item.commodity.stockPriceScale) }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }">{{ item.calcGrossProfit | numeric(item.commodity.stockPriceScale) }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }">{{ item.itemRequestDate | date }}</GridItem>    
                <GridItem :slot="gridConfig.gridSlots[17]" slot-scope="{ item }">{{ item.answerDeliveryDate | date }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[18]" slot-scope="{ item }">{{ item.scheduledDeliveryDate | date }}</GridItem>     
                <GridItem :slot="gridConfig.gridSlots[19]" slot-scope="{ item }">{{ item.supplier? item.supplier.name: '' }}</GridItem>       
                <GridItem :slot="gridConfig.gridSlots[20]" slot-scope="{ item }">{{ item.subscriptionStartDate | date }}</GridItem>    
                <GridItem :slot="gridConfig.gridSlots[21]" slot-scope="{ item }">{{ item.subscriptionEndDate | date }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[22]" slot-scope="{ item }">{{ item.monthlyQuantity | numeric(item.commodity.quantityScale) }}</GridItem>     
                <GridItem :slot="gridConfig.gridSlots[23]" slot-scope="{ item }">{{ item.monthlyQuantity * item.unitPrice | amountFC(item.order.currencyCode) }}</GridItem>     
                <GridItem :slot="gridConfig.gridSlots[24]" slot-scope="{ item }">{{ item.nextSettlementDate  | date }}</GridItem>                       
                <GridItem :slot="gridConfig.gridSlots[25]" slot-scope="{ item }">{{ item.description}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[26]" slot-scope="{ item }">{{ item.commodityName}}</GridItem>
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+26]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                    
            </Grid>
          <!-- 出荷明細(出荷伝票) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesDeliveryItem && voucherType == voucherTypes.SalesDelivery" storageKey="v_items_SalesDeliveryItem_SalesDelivery" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                     
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryInvoiceItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.deliveryItemNo }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.model }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku ? item.sku.name :''}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>                       
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>      
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.scannedQuantity | numeric(item.commodity.quantityScale) }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.isScanCompleted | inspectionFlags }}</GridItem>                           
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.delivery != null ? item.delivery.currencyCode : null) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }" :link="item.linkOrderItem">{{ item.orderItemNo }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item }" :link="item.linkOrder">{{ item.orderNo }}</GridItem>                         
                <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item }" :link="item.linkInvoice">{{ item.invoiceNo }}</GridItem>   
                <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }">{{ item.description}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }">{{ item.commodityName}}</GridItem>
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+16]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                           
            </Grid>
          <!-- 出荷明細(請求書) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesDeliveryItem && voucherType == voucherTypes.SalesInvoice" storageKey="v_items_SalesDeliveryItem_SalesInvoice" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                     
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryInvoiceItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true"  @click="onEdit(item)">{{ item.deliveryItemNo }}</GridItem>       
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>                                                               
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku ? item.sku.name :''}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale)}}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.delivery != null ? item.delivery.currencyCode : null) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :link="item.linkDelivery">{{ item.deliveryNo }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }" :link="item.linkOrderItem">{{ item.orderItemNo }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }" :link="item.linkOrder">{{ item.orderNo }}</GridItem>              
                <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item }">{{ item.description}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item }">{{ item.commodityName}}</GridItem>
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+14]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                              
            </Grid>
          <!-- 出荷明細(受注明細) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesDeliveryItem && voucherType == voucherTypes.SalesOrderItem" storageKey="v_items_SalesDeliveryItem_SalesOrderItem" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                     
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryInvoiceItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :link="item.linkDeliveryItem">{{ item.deliveryItemNo }}</GridItem>         
                <!-- <GridItem :slot="col2" slot-scope="{ item }">{{ item.scheduleDeliveryDate | date }}</GridItem>                                                           -->
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>                                                          
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku ? item.sku.name :''}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :link="item.linkDelivery">{{ item.deliveryNo }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :link="item.linkInvoice">{{ item.invoiceNo }}</GridItem>       
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+10]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                            
            </Grid>
          <!-- 発注明細(受注明細) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseOrderItem   && voucherType == voucherTypes.SalesOrderItem" storageKey="v_items_PurchaseOrderItem_SalesOrderItem" :items="items" :isLoading="isLoading"  

            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseOrderItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :link="item.linkOrderItem">{{ item.orderItemNo }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.order.orderDate | date }}</GridItem>                
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">
                  <span class="cx_link_item" @click="showPopover(item.orderItemNo,voucherTypes.PurchaseDeliveryItem,$event)" :tabindex="-1">入荷</span>
                </GridItem>                       
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.backOrderQuantity | numeric(item.commodity.quantityScale) }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>                           
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+10]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                            
            </Grid>  
          <!-- 発注明細(発注伝票) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseOrderItem   && voucherType == voucherTypes.PurchaseOrder" storageKey="v_items_PurchaseOrderItem_PurchaseOrder" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseOrderItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.orderItemNo }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">
                  <span class="cx_link_item" @click="showPopover(item.orderItemNo,voucherTypes.PurchaseDeliveryItem,$event)" :tabindex="-1">入荷</span>
                </GridItem>                       
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{item.commodity.model }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }"><BtnStockSchedule :commodity="item.commodity" :sku="item.sku" :segment="item.order.segment" :stockDate="item.scheduledDeliveryDate"/></GridItem>                   
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.backOrderQuantity | numeric(item.commodity.quantityScale)  }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale)}}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.order.currencyCode) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>       
                <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item }">{{ item.itemRequestDate | date }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item }">{{ item.answerDeliveryDate | date }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }">{{ item.scheduledDeliveryDate | date }}</GridItem>                
                <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }" :link="item.linkSalesOrderItem">{{ item.salesOrderItemNo }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[17]" slot-scope="{ item }" :link="item.linkSalesOrder">{{ item.salesOrderNo }}</GridItem>                                
                <GridItem :slot="gridConfig.gridSlots[18]" slot-scope="{ item }">{{ item.description}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[19]" slot-scope="{ item }">{{ item.commodityName}}</GridItem>
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+19]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                                            
            </Grid>   
          <!-- 入荷明細(発注明細) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseDeliveryItem  && voucherType == voucherTypes.PurchaseOrderItem" storageKey="v_items_PurchaseDeliveryItem_PurchaseOrderItem" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseDeliveryItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :link="item.linkDeliveryItem">{{ item.deliveryItemNo }}</GridItem>     
                <!-- <GridItem :slot="col2" slot-scope="{ item }">{{ item.scheduleDeliveryDate | date }}</GridItem>              -->
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>                                

                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku ? item.sku.name :''}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale)}}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>         
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :link="item.linkDelivery">{{ item.deliveryNo }}</GridItem>                                                                                 
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+9]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                                                        
            </Grid>            
          <!-- 入荷明細(入荷伝票) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseDeliveryItem  && voucherType == voucherTypes.PurchaseDelivery" storageKey="v_items_PurchaseDeliveryItem_PurchaseDelivery" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseDeliveryItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.deliveryItemNo }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.model }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku ? item.sku.name :''}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.scannedQuantity | numeric(item.commodity.quantityScale) }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.isScanCompleted | inspectionFlags }}</GridItem>                  
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale)}}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.delivery != null ? item.delivery.currencyCode : null) }}</GridItem> 
                <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }" :link="item.linkOrderItem">{{ item.orderItemNo }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item }" :link="item.linkOrder">{{ item.orderNo }}</GridItem>        
                <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item }" :link="item.linkSalesOrderItem">{{ item.salesOrderItemNo }}</GridItem>          
                <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }" :link="item.linkSalesOrder">{{ item.salesOrderNo }}</GridItem>                                                             
                <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }">{{ item.description}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[17]" slot-scope="{ item }">{{ item.commodityName}}</GridItem>
                <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+17]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                                                                    
            </Grid>
              <!-- 諸掛明細(入荷伝票・出荷伝票) ～現在、使用されていない -->
                <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseCharge || voucherItemType == voucherTypes.SalesCharge " storageKey="v_items_PurchaseCharge_SalesCharge" :items="items" :isLoading="isLoading"  
                :captions="gridConfig.gridCaptions"
                :widths="gridConfig.gridWidths" 
                ref="grid"
                :showCheckBox="showCheckBox"                                     
                :visibles="gridConfig.gridVisibles">  
                    <!-- 明細項目の配置 -->
                    <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="chargeStatus"/></GridItem>
                    <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :link="item.linkCharge">{{ item.chargeNo }}</GridItem>            
                    <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{item.chargeDate | date }}</GridItem>
                    <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{item.dueDate | date }}</GridItem>
                    <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{item.counterpart.name }}</GridItem> 
                    <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{item.account.name }}</GridItem>            
                    <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }" :right="true">{{item.dealAmountFC | amountFC(item.currencyCode)  }}</GridItem> 
                    <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{item.taxCode | taxCode }}</GridItem>          
                    <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{item.proportionalDivision | proportionalDivisionFlags }}</GridItem>                                                     
                    <!-- <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+8]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                                                                                     -->
                </Grid>
              <!-- 諸掛按分明細(入荷明細・出荷明細) -->
                <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseChargeItem || voucherItemType == voucherTypes.SalesChargeItem " storageKey="v_items_PurchaseChargeItem_SalesChargeItem" :items="items" :isLoading="isLoading"  
                :captions="gridConfig.gridCaptions"
                :widths="gridConfig.gridWidths" 
                ref="grid"
                :showCheckBox="showCheckBox"                                     
                :visibles="gridConfig.gridVisibles">  
                    <!-- 明細項目の配置 -->
                    <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.charge.state" list="chargeStatus"/></GridItem>
                    <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }">{{ item.chargeItemNo }}</GridItem>            
                    <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{item.charge.chargeDate | date }}</GridItem>
                    <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{item.charge.counterpart.name }}</GridItem> 
                    <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{item.charge.account.name }}</GridItem>            
                    <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{item.amount | amount}}</GridItem> 
                    <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }"  :link="item.linkCharge">{{ item.chargeNo }}</GridItem>                                               
                    <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+6]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>                                                                                    
                </Grid>       

              <!-- 商品マスタ 単価タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.CommodityPrice" storageKey="v_items_CommodityPrice" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ '編集' }}</GridItem>                 
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{  item.sku == null ? "" : item.sku.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.priceType | priceTypes }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.currency | currency }}</GridItem>    
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.price | numeric}}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.conversion.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.tax | taxCode }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.counterpartPriceCategory | category_101 }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }">{{ item.startDate | date }}</GridItem>                          
            </Grid>   
              <!-- 商品マスタ SKUタブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.CommoditySKU" storageKey="v_items_CommoditySKU" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.code }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.barcodeType | barcodeTypes }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.barcode }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.minimumStockQuantity | numeric(item.commodity.quantityScale)  }}</GridItem>                            
            </Grid>   
              <!-- 商品マスタ 荷姿タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.CommodityConversion" storageKey="v_items_CommodityConversion" :items="items" :isLoading="isLoading"  
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.code }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }" :right="true">{{ item.rate }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }" :right="true">{{ item.netWeight }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.grossWeight }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }" :right="true">{{ item.measurement }}</GridItem>                       
            </Grid>   
              <!-- 商品マスタ 棚番号タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.CommodityShelfNo" storageKey="v_items_CommodityShelfNo" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ '編集' }}</GridItem>                
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.warehouse.name }}</GridItem>    
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{  item.sku ? item.sku.name : '' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.shelfNo }}</GridItem>                    
            </Grid>   

              <!-- 在庫移動明細タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.StockRelocationItem" storageKey="v_items_StockRelocationItem" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="stockRelocationItemStatus"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.stockRelocationItemNo }}</GridItem>    
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.commodity.uom }}</GridItem>    
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>                     
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale)  }}</GridItem>              
                 <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+6]" slot-scope="{ item }">{{getPropValueIn(item,index)}}</GridItem>                        
            </Grid>   
              <!-- 在庫振替明細タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.StockTransferItem" storageKey="v_items_StockTransferItem" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->

            </Grid>   
              <!-- 棚卸処理明細タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.StockTakingItem" storageKey="v_items_StockTakingItem" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="stockTakingItemStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }"   :func="true" @click="onEdit(item)">{{ item.stockTakingItemNo }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.shelfNo == null ? "" : item.shelfNo.shelfNo }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.commodity.uom }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>                   
              <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.targetQuantity | numeric(item.commodity.quantityScale)  }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.scannedQuantity | numeric(item.commodity.quantityScale)  }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.isScanCompleted | inspectionFlags }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale)  }}</GridItem>                                          
              <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+10]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>         
            </Grid>   
              <!-- セット品マスタ　構成品タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.Component" storageKey="v_items_Component" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ '編集' }}</GridItem>               
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.componentCommodity.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }" :right="true">{{ item.componentQuantity | numeric(item.componentCommodity.quantityScale) }}</GridItem>
            </Grid>  
            <!-- ピッキング明細タブ -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PickingItem" storageKey="v_items_PickingItem" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }">{{ item.pickingItemNo }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.uomHasInitial.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale)  }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }" :right="true">{{ item.scannedQuantity | numeric(item.commodity.quantityScale)  }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }" :right="true">{{ item.isScanCompleted | inspectionFlags }}</GridItem>                                    
              <GridItem v-for="index in 15" :key="index" :data-item-id="index" :slot="gridConfig.gridSlots[index+6]" slot-scope="{ item }">{{getPropValue(item,index)}}</GridItem>         
            </Grid>            
            <!-- 受注伝票タブ(案件一覧) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesOrder" storageKey="v_items_SalesOrder" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesOrderStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }"  :func="true" @click="onEdit(item)">{{ item.orderNo }}</GridItem> 
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.orderDate | date }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.requestDate | date }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem> 
              <!-- <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.currencyCode | currency }}</GridItem> -->
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.refNo }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.customerOrderNo }}</GridItem>       
              <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode)}}</GridItem>                
            </Grid>           
            <!-- 発注伝票タブ(案件一覧) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseOrder" storageKey="v_items_PurchaseOrder" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseOrderStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }"  :func="true" @click="onEdit(item)">{{ item.orderNo }}</GridItem> 
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.orderDate | date }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.requestDate | date }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlagsHasServices }}</GridItem>    
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode) }}</GridItem>                          
            </Grid>                 
            <!-- 出荷伝票タブ(案件一覧) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesDelivery" storageKey="v_items_SalesDelivery" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryStatus"/></GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.deliveryNo }}</GridItem>  
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>    
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlags }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>   
              <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode) }}</GridItem>               

            </Grid>        
            <!-- 入荷伝票タブ(案件一覧) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseDelivery" storageKey="v_items_PurchaseDelivery" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
                <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseDeliveryStatus2"/></GridItem>
                <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }" :func="true" @click="onEdit(item)">{{ item.deliveryNo }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.bookDate | date }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlagsHasServices }}</GridItem>    
                <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem>
                <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode) }}</GridItem>               
            </Grid>            
            <!-- 在庫タブ(案件一覧) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.StockBalance" storageKey="v_items_StockBalance" :items="items" :isLoading="isLoading" 
            :captions="gridConfig.gridCaptions"
            :widths="gridConfig.gridWidths" 
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :visibles="gridConfig.gridVisibles">  
                <!-- 明細項目の配置 -->
              <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }">{{ item.closingDate | dateYM }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }">{{ item.stockKey.segmentId | segment }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.stockKey.warehouse ? item.stockKey.warehouse.name : '' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.stockKey.commodity ? item.stockKey.commodity.name : '端数調整口' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.stockKey.commodity ? item.stockKey.commodity.model : '' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.stockKey.skuId ? item.stockKey.sku.name : '' }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }" :right="true">{{ item.stockQuantity | numeric(item.quantityScale)  }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }" :right="true">{{ item.totalConsignmentQuantity | numeric(item.quantityScale)  }}</GridItem>              
              <!-- <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.stockPrice | numeric(item.priceScale)  }}</GridItem>
              <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }" :right="true">{{ item.totalStockAmount | amount  }}</GridItem>               -->
            </Grid>                          
        </div>              
        <div v-if="popover"  >
            <!-- 発注明細(ポップオーバー) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseOrderItem" storageKey="v_items_popover_PurchaseOrderItem" :items="items" :isLoading="isLoading"  :height="150"
            :captions=" ['状態','発注番号',  '明細番号','発注日',  '発注数量', '発注残数量', '単位']"
            ref="grid"
            :showCheckBox="showCheckBox"                                 
            :widths="[100,120,150,120,100,100,100]"  :showGearButton="false">  
                <!-- 明細項目の配置 -->
                <GridItem slot="col0" slot-scope="{ item }"><Badge :value="item.state" list="purchaseOrderItemStatus"/></GridItem>
                <GridItem slot="col1" slot-scope="{ item }" :link="item.linkOrder">{{ item.orderNo }}</GridItem>                           
                <GridItem slot="col2" slot-scope="{ item }" :link="item.linkOrderItem">{{ item.orderItemNo }}</GridItem>
                <GridItem slot="col3" slot-scope="{ item }">{{ item.order.orderDate | date }}</GridItem>                                
                <GridItem slot="col4" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
                <GridItem slot="col5" slot-scope="{ item }" :right="true">{{ item.backOrderQuantity | numeric(item.commodity.quantityScale) }}</GridItem>            
                <GridItem slot="col6" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>                                   
            </Grid>   
            <!-- 出荷明細(ポップオーバー) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.SalesDeliveryItem" storageKey="v_items_popover_SalesDeliveryItem" :items="items" :isLoading="isLoading"  :height="150"
            ref="grid"
            :showCheckBox="showCheckBox"                     
            :captions=" ['状態','出荷番号', '明細番号','出荷予定日', '数量', '単位', '請求書番号']"
            :widths="[100,120,150,120,100,100,120]"  :showGearButton="false">  
                <!-- 明細項目の配置 -->
                <GridItem slot="col0" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryInvoiceItemStatus"/></GridItem>
                <GridItem slot="col1" slot-scope="{ item }" :link="item.linkDelivery">{{ item.deliveryNo }}</GridItem>  
                <GridItem slot="col2" slot-scope="{ item }" :link="item.linkDeliveryItem">{{ item.deliveryItemNo }}</GridItem>
                <GridItem slot="col3" slot-scope="{ item }">{{ item.scheduleDeliveryDate | date }}</GridItem>                        
                <GridItem slot="col4" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem> 
                <GridItem slot="col5" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>            
                <GridItem slot="col6" slot-scope="{ item }" :link="item.linkInvoice">{{ item.invoiceNo }}</GridItem>                                   
            </Grid>         
            <!-- 入荷明細(ポップオーバー) -->
            <Grid class="grid" v-if="voucherItemType == voucherTypes.PurchaseDeliveryItem" storageKey="v_items_popover_PurchaseDeliveryItem" :items="items" :isLoading="isLoading"  :height="150"
            ref="grid"
            :showCheckBox="showCheckBox"                     
            :captions=" ['状態','入荷番号',  '明細番号','入荷予定日',  '数量', '単位']"
            :widths="[100,120,150,120,120,120]"  :showGearButton="false">  
                <!-- 明細項目の配置 -->
                <GridItem slot="col0" slot-scope="{ item }"><Badge :value="item.virtualState" list="purchaseDeliveryItemStatus"/></GridItem>
                <GridItem slot="col1" slot-scope="{ item }" :link="item.linkDelivery">{{ item.deliveryNo }}</GridItem>                        
                <GridItem slot="col2" slot-scope="{ item }" :link="item.linkDeliveryItem">{{ item.deliveryItemNo }}</GridItem>
                <GridItem slot="col3" slot-scope="{ item }">{{ item.scheduleDeliveryDate | date }}</GridItem>                                         
                <GridItem slot="col4" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem> 
                <GridItem slot="col5" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>      
                             
            </Grid>     

        </div>         
          <!-- 明細ポップオーバー -->
          <b-popover   :target="popoverTarget" boundary="window" ref="popover" placement="top" v-if="popoverVisible" :show="popoverVisible">
              <GrdVoucherItem :voucherNo="popoverVoucherNo" :popover="true" :voucherType="voucherItemType" :voucherItemType="popoverItemType" />
          </b-popover>           
          <slot name="popupEditor" :parent="_self"></slot>                         
    </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/tenant/common';
import { LoadResult } from '@/agiles/common';
import { normalizeUnits } from 'moment';

@Component
export default class GrdVoucherItem extends Vue {
  @Prop() public voucherType : Common.voucherTypes; //クエリ  
  @Prop() public voucherItemType : Common.voucherTypes; //クエリ
  @Prop({default: '' }) public voucherNo: string; //伝票番号
  @Prop({default:false}) public popover : boolean; //クエリ
  @Prop({default:false}) public showCheckBox : boolean;
  @Prop({default:false}) public isBarcodeInspection : boolean;
  @Prop() public comparer: (a:any,b:any)=> boolean;

  public get selectedItems(): any[] {
    return (this.$refs.grid as Components.Grid).selectedItems;
  }

  public items: any[] = new Array(0); //リスト
  public isLoading:boolean = false;
  public voucherTypes = Common.voucherTypes; //voucherTypesのエイリアス
  public InvoiceTypes = Common.InvoiceTypes; //InvoiceTypesのエイリアス

  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseTrade:boolean = false;

  public created(){
    this.tenantSettings = this.$api.tenantSettings;
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.export) || this.$api.hasLicense(Common.licenseFlags.import) ;

    if (this.voucherItemType == Common.voucherTypes.SalesOrderItem){
      // this.gridConfig.setGridItemsFromCaptions(
      //   ['状態',  '明細番号','明細表示',  '商品', '型番',  'SKU','在庫', '受注数量', '受注残数量', '単位', '単価', '税区分','上代単価','仕入単価','粗利','希望納期','回答納期','出荷予定日','発注先','契約開始日','契約完了日','月次数量','次回清算日'],
      //   [120,150,150,120,120,100,120,120,120,120,120,120,120,120,120,120,120,120,120,120]);

       this.gridConfig.setGridItems(
          new Common.GridItemConfiguration('状態',120),
          new Common.GridItemConfiguration('明細番号',150),
          new Common.GridItemConfiguration('明細表示',150),
          new Common.GridItemConfiguration('商品',120),
          new Common.GridItemConfiguration('型番',120),
          new Common.GridItemConfiguration('SKU',100),
          new Common.GridItemConfiguration('在庫',100,this.$api.useStockFunction),
          new Common.GridItemConfiguration('受注数量',120),
          new Common.GridItemConfiguration('受注残数量',120),
          new Common.GridItemConfiguration('単位',120),
          new Common.GridItemConfiguration('単価',120),
          new Common.GridItemConfiguration('取引金額',120),
          new Common.GridItemConfiguration('税区分',120),
          new Common.GridItemConfiguration('上代単価',120),
          new Common.GridItemConfiguration('仕入単価',120),
          new Common.GridItemConfiguration('粗利',120),
          new Common.GridItemConfiguration('希望納期',120),
          new Common.GridItemConfiguration('回答納期',120),
          new Common.GridItemConfiguration('出荷予定日',120),
          new Common.GridItemConfiguration('発注先',120),
          new Common.GridItemConfiguration('契約開始日',120),
          new Common.GridItemConfiguration('契約完了日',120),
          new Common.GridItemConfiguration('月次数量',120),
          new Common.GridItemConfiguration('月次金額',120),
          new Common.GridItemConfiguration('次回清算日',120),
          new Common.GridItemConfiguration('備考',200),
          new Common.GridItemConfiguration('商品名称',120,true,false),
       );


    } else if (this.voucherItemType == Common.voucherTypes.SalesDeliveryItem && this.voucherType == Common.voucherTypes.SalesDelivery) {
      // this.gridConfig.setGridItemsFromCaptions(
      //   ['状態',  '明細番号', '商品',  'SKU', '出荷数量', '単位', '検品数量','検品区分','単価', '税区分','受注明細番号','受注番号','請求書番号'],
      //  [120,150,120,150,120,120,120,80,120,120,120,120,120]);

       this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 120),
        new Common.GridItemConfiguration('明細番号', 150),
        new Common.GridItemConfiguration('商品', 120),
        new Common.GridItemConfiguration('型番', 120),
        new Common.GridItemConfiguration('SKU', 150),
        new Common.GridItemConfiguration('出荷数量', 120),        
        new Common.GridItemConfiguration('単位', 120),  
        new Common.GridItemConfiguration('検品数量', 80,this.isBarcodeInspection),           
        new Common.GridItemConfiguration('検品区分', 120,this.isBarcodeInspection),      
        new Common.GridItemConfiguration('単価', 120),  
        new Common.GridItemConfiguration('取引金額',120),
        new Common.GridItemConfiguration('税区分', 120),           
        new Common.GridItemConfiguration('受注明細番号', 120),      
        new Common.GridItemConfiguration('受注番号', 120),      
        new Common.GridItemConfiguration('請求書番号', 120),             
        new Common.GridItemConfiguration('備考',200),
        new Common.GridItemConfiguration('商品名称',120,true,false),
       );

    } else if (this.voucherItemType == Common.voucherTypes.SalesDeliveryItem && this.voucherType == Common.voucherTypes.SalesInvoice) {
      this.gridConfig.setGridItemsFromCaptions(
       ['状態',  '明細番号','出荷日', '商品','SKU', '出荷数量', '単位', '単価', '取引金額', '税区分','出荷番号','受注明細番号','受注番号','備考'],
       [120,150,120,120,150,120,120,120,120,120,120,120,120,200]);
      this.gridConfig.setGridItems(new Common.GridItemConfiguration('商品名称',120,true,false));
    } else if (this.voucherItemType == Common.voucherTypes.SalesDeliveryItem && this.voucherType == Common.voucherTypes.SalesOrderItem) {
      this.gridConfig.setGridItemsFromCaptions(
       ['状態',  '明細番号','出荷日', '商品','SKU', '出荷数量', '単位', '単価', '税区分','出荷番号','請求書番号'],
       [120,150,120,120,150,120,120,120,120,120,120,120]);
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseOrderItem   && this.voucherType == Common.voucherTypes.SalesOrderItem) {
      this.gridConfig.setGridItemsFromCaptions(
       ['状態',  '明細番号','発注日', '明細表示', '商品',  'SKU', '発注数量', '発注残数量', '単位', '単価', '税区分'],
       [120,150,120,120,120,120,120,120,120,120,120]);
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseOrderItem   && this.voucherType == Common.voucherTypes.PurchaseOrder) {
      // this.gridConfig.setGridItemsFromCaptions(
      //  ['状態',  '明細番号', '明細表示', '商品', '型番',  'SKU','在庫', '発注数量', '発注残数量', '単位', '単価', '税区分','希望納期','回答納期','入荷予定日','受注明細番号','受注番号'],
      //  [120,150,120,120,120,120,100,120,120,120,120,120,120,120,120,120,120]);      
       this.gridConfig.setGridItems(
          new Common.GridItemConfiguration('状態',120),
          new Common.GridItemConfiguration('明細番号',150),
          new Common.GridItemConfiguration('明細表示',120),
          new Common.GridItemConfiguration('商品',120),
          new Common.GridItemConfiguration('型番',120),
          new Common.GridItemConfiguration('SKU',120),
          new Common.GridItemConfiguration('在庫',100,this.$api.useStockFunction),
          new Common.GridItemConfiguration('発注数量',120),
          new Common.GridItemConfiguration('発注残数量',120),
          new Common.GridItemConfiguration('単位',120),
          new Common.GridItemConfiguration('単価',120),
          new Common.GridItemConfiguration('取引金額',120),
          new Common.GridItemConfiguration('税区分',120),
          new Common.GridItemConfiguration('希望納期',120),
          new Common.GridItemConfiguration('回答納期',120),
          new Common.GridItemConfiguration('入荷予定日',120),
          new Common.GridItemConfiguration('受注明細番号',120),
          new Common.GridItemConfiguration('受注番号',120),
          new Common.GridItemConfiguration('備考',200),
          new Common.GridItemConfiguration('商品名称',120,true,false)
       );
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseDeliveryItem  && this.voucherType == Common.voucherTypes.PurchaseOrderItem) {
      this.gridConfig.setGridItemsFromCaptions(
       ['状態',  '明細番号','入荷日', '商品',  'SKU', '入荷数量', '単位', '単価', '税区分','入荷番号'],
       [120,150,120,120,150,120,120,120,120,120]);      
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseDeliveryItem  && this.voucherType == Common.voucherTypes.PurchaseDelivery) {
      // this.gridConfig.setGridItemsFromCaptions(
      //  ['状態',  '明細番号', '商品',  'SKU', '入荷数量', '単位', '検品数量','検品区分', '単価', '税区分','発注明細番号','発注番号','受注明細番号','受注番号'],
      //  [120,150,120,150,120,120,120,80,120,120,120,120,120,120,120]);  

       this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 120),
        new Common.GridItemConfiguration('明細番号', 150),
        new Common.GridItemConfiguration('商品', 120),
        new Common.GridItemConfiguration('型番', 120),
        new Common.GridItemConfiguration('SKU', 150),
        new Common.GridItemConfiguration('入荷数量', 120),        
        new Common.GridItemConfiguration('単位', 120),  
        new Common.GridItemConfiguration('検品数量', 80,this.isBarcodeInspection),           
        new Common.GridItemConfiguration('検品区分', 120,this.isBarcodeInspection),      
        new Common.GridItemConfiguration('単価', 120),  
        new Common.GridItemConfiguration('取引金額',120),
        new Common.GridItemConfiguration('税区分', 120),           
        new Common.GridItemConfiguration('発注明細番号', 120),      
        new Common.GridItemConfiguration('発注番号', 120),      
        new Common.GridItemConfiguration('受注明細番号', 120),             
        new Common.GridItemConfiguration('受注番号', 120),                
        new Common.GridItemConfiguration('備考',200),
        new Common.GridItemConfiguration('商品名称',120,true,false),
       );


    } else if (this.voucherItemType == Common.voucherTypes.PurchaseCharge || this.voucherItemType == Common.voucherTypes.SalesCharge ) {
      this.gridConfig.setGridItemsFromCaptions(
       ['状態',  '諸掛番号', '発生日',  '支払予定日', '諸掛取引先', '勘定科目', '取引金額', '税区分','按分方法'],
       [120,120,120,150,120,120,120,120,120]);  
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseChargeItem || this.voucherItemType == Common.voucherTypes.SalesChargeItem ) {
      this.gridConfig.setGridItemsFromCaptions(
       ['状態',  '諸掛明細番号', '発生日',   '諸掛取引先', '勘定科目', '諸掛按分額', '諸掛番号'],
       [120,150,120,150,120,120,120]);  
    } else if (this.voucherItemType == Common.voucherTypes.CommodityPrice){
      this.gridConfig.setGridItemsFromCaptions(
       ['状態', '', 'SKU', '単価区分',   '通貨', '標準単価', '単位', '税区分', '取引先単価区分', '価格改定日'],
       [120,60,120,120,150,120,120,120,120,120]);  
    } else if (this.voucherItemType == Common.voucherTypes.CommoditySKU){
      this.gridConfig.setGridItemsFromCaptions(
       ['状態', 'コード', '名称', 'バーコード種類', '商品バーコード','補充基準数量', ],
       [100,  150, 150, 150, 200, 150]);  
    } else if (this.voucherItemType == Common.voucherTypes.CommodityConversion){

      this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 100),
        new Common.GridItemConfiguration('コード', 150),
        new Common.GridItemConfiguration('名称', 200),
        new Common.GridItemConfiguration('入数(換算係数)', 150),
        new Common.GridItemConfiguration('Net(kg)', 150,this.hasLicenseTrade),
        new Common.GridItemConfiguration('Gross(kg)', 150,this.hasLicenseTrade),
        new Common.GridItemConfiguration('Volume(m3)', 150,this.hasLicenseTrade),
      );
    } else if (this.voucherItemType == Common.voucherTypes.CommodityShelfNo){
      this.gridConfig.setGridItemsFromCaptions(
       ['状態', '','倉庫',  'SKU', '棚番号', ],
       [100, 60, 150, 150, 150]);  
    } else if (this.voucherItemType == Common.voucherTypes.StockRelocationItem){
      this.gridConfig.setGridItemsFromCaptions(
       ['状態','明細番号','商品','SKU','単位','案件','移動数量'],
       [100,  150, 150, 150, 150, 150]);      
    } else if (this.voucherItemType == Common.voucherTypes.StockTransferItem){
      this.gridConfig.setGridItemsFromCaptions(
       [],
       []);  
    } else if (this.voucherItemType == Common.voucherTypes.StockTakingItem){      
      // this.gridConfig.setGridItemsFromCaptions(
      //  ['状態','明細番号','棚番号','商品','SKU','単位','減耗数量'],
      //  [100, 150, 150, 150, 150, 150,150]);  

       this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 100),
        new Common.GridItemConfiguration('明細番号', 150),
        new Common.GridItemConfiguration('棚番号', 150),
        new Common.GridItemConfiguration('商品', 150),
        new Common.GridItemConfiguration('SKU', 150),
        new Common.GridItemConfiguration('単位', 150),        
        new Common.GridItemConfiguration('案件', 150),          
        new Common.GridItemConfiguration('指示数量', 150,this.isBarcodeInspection),        
        new Common.GridItemConfiguration('検品数量', 150,this.isBarcodeInspection),        
        new Common.GridItemConfiguration('検品区分', 150,this.isBarcodeInspection),                                
        new Common.GridItemConfiguration('減耗数量', 150)           
       );
    } else if (this.voucherItemType == Common.voucherTypes.PickingItem){
       this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('明細番号', 150),
        new Common.GridItemConfiguration('商品', 150),
        new Common.GridItemConfiguration('SKU', 150),
        new Common.GridItemConfiguration('単位', 150),        
        new Common.GridItemConfiguration('指示数量', 150),        
        new Common.GridItemConfiguration('検品数量', 150,this.isBarcodeInspection),        
        new Common.GridItemConfiguration('検品区分', 150,this.isBarcodeInspection),           
       );                     
    
    } else if (this.voucherItemType == Common.voucherTypes.Component){
      this.gridConfig.setGridItemsFromCaptions(
       ['状態','','構成品商品','構成品SKU','構成品数量'],
       [100, 60,150, 150, 150]);  
    }  else if (this.voucherItemType == Common.voucherTypes.SalesOrder){
      this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 150),
        new Common.GridItemConfiguration('受注番号', 150),
        new Common.GridItemConfiguration('受注日', 120),
        new Common.GridItemConfiguration('得意先', 200),
        new Common.GridItemConfiguration('希望納期', 120),
        new Common.GridItemConfiguration('納入先', 200),
        // new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
        new Common.GridItemConfiguration('受注管理番号', 120),
        new Common.GridItemConfiguration('顧客注文番号', 150),
        new Common.GridItemConfiguration('受注金額', 120),        
      );    
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseOrder){
      this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 150),
        new Common.GridItemConfiguration('発注番号', 150),
        new Common.GridItemConfiguration('発注日', 120),
        new Common.GridItemConfiguration('仕入先', 120),
        new Common.GridItemConfiguration('希望納期', 120),
        new Common.GridItemConfiguration('納入区分', 120),      
        new Common.GridItemConfiguration('入庫倉庫', 120),
        new Common.GridItemConfiguration('納入先', 120),  
        new Common.GridItemConfiguration('発注金額', 120),        
      );    
    } else if (this.voucherItemType == Common.voucherTypes.SalesDelivery){
      this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 150),
        new Common.GridItemConfiguration('出荷番号', 150),
        new Common.GridItemConfiguration('出荷日', 150),
        new Common.GridItemConfiguration('得意先', 150),
        new Common.GridItemConfiguration('納入先', 150),
        new Common.GridItemConfiguration('納入区分', 150),
        new Common.GridItemConfiguration('出庫倉庫', 150),
        new Common.GridItemConfiguration('出荷金額', 150),        
      );    
    } else if (this.voucherItemType == Common.voucherTypes.PurchaseDelivery){
      this.gridConfig.setGridItems(
        new Common.GridItemConfiguration('状態', 200),
        new Common.GridItemConfiguration('入荷番号', 120), 
        new Common.GridItemConfiguration('仕入日', 120),
        new Common.GridItemConfiguration('仕入先', 180),
        new Common.GridItemConfiguration('納入区分', 120),
        new Common.GridItemConfiguration('入荷日', 120),
        new Common.GridItemConfiguration('入庫倉庫', 150),
        new Common.GridItemConfiguration('納入先', 150),
        new Common.GridItemConfiguration('入荷金額', 120),              
      );    
    } else if (this.voucherItemType == Common.voucherTypes.StockBalance){
    this.gridConfig.setGridItemsFromCaptions(
      ['限月', '部門', '倉庫', '商品', '型番', 'SKU','庫内数量','積送数量'],
      [120, 120, 120, 120, 150, 150, 120, 120,]
    );
    } 

  

    switch (this.voucherItemType) {
      case Common.voucherTypes.SalesOrderItem:
        //商品識別情報,商品メモ,受発注メモを追加
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false,'',false)); break;
      case Common.voucherTypes.PurchaseOrderItem:
        //商品識別情報,商品メモ,受発注メモを追加
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false,'',false)); break;          
      case Common.voucherTypes.Component:        
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,false,false,'',false)); break;
      case Common.voucherTypes.SalesDeliveryItem:
        //商品識別情報,在庫識別情報,商品メモ,入出荷メモを追加
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,true,'',false)); break;        
      case Common.voucherTypes.SalesChargeItem:
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,false,false,false,'',false)); break;
      case Common.voucherTypes.PurchaseDeliveryItem:
        //商品識別情報,在庫識別情報,商品メモ,入出荷メモを追加
         this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,true,'',false)); break;
      case Common.voucherTypes.PurchaseChargeItem:    
         this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,false,false,false,'',false)); break;
      case Common.voucherTypes.StockTransferItem:
      case Common.voucherTypes.StockTakingItem:　 
      case Common.voucherTypes.PickingItem:　       
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,'',false));  break;
      case Common.voucherTypes.StockRelocationItem:
        this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,'入庫|',false));  break;  
      default: break;
    }
    //予備項目の追加
    // if (this.voucherItemType == Common.voucherTypes.CommodityPrice || this.voucherItemType == Common.voucherTypes.CommoditySKU || this.voucherItemType == Common.voucherTypes.CommodityShelfNo ||this.voucherItemType == Common.voucherTypes.CommodityConversion){
    //   //何も追加しない    
    // } else if (this.voucherItemType == Common.voucherTypes.PurchaseCharge || this.voucherItemType == Common.voucherTypes.SalesCharge) {
    //   //諸掛本体は明細ではない
    // } else if (this.voucherItemType == Common.voucherTypes.SalesOrderItem || this.voucherItemType == Common.voucherTypes.PurchaseOrderItem || this.voucherItemType == Common.voucherTypes.Component) {
    //   //商品属性を追加
    //   this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,'',false));
    // } else {
    // 　//商品属性と在庫属性を追加
    //   this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,'',false));    
    // }

  }

  public get title() {
    return this.getTitle(this.voucherType,this.voucherItemType);
  }
  public getTitle(voucherType: Common.voucherTypes, voucherItemType: Common.voucherTypes):string {    
    if (voucherItemType == Common.voucherTypes.SalesOrderItem) return '受注明細';
    if (voucherItemType == Common.voucherTypes.SalesDeliveryItem && voucherType != Common.voucherTypes.SalesInvoice) return '出荷明細';
    if (voucherItemType == Common.voucherTypes.SalesDeliveryItem && voucherType == Common.voucherTypes.SalesInvoice) return '請求明細';    
    if (voucherItemType == Common.voucherTypes.SalesCharge) return '売上諸掛';
    if (voucherItemType == Common.voucherTypes.SalesChargeItem) return '売上諸掛按分明細';
    if (voucherItemType == Common.voucherTypes.PurchaseOrderItem) return '発注明細';        
    if (voucherItemType == Common.voucherTypes.PurchaseDeliveryItem) return '入荷明細';    
    if (voucherItemType == Common.voucherTypes.PurchaseCharge) return '仕入諸掛';    
    if (voucherItemType == Common.voucherTypes.PurchaseChargeItem) return '仕入諸掛按分明細';              

    if (voucherItemType == Common.voucherTypes.CommodityPrice) return '単価';          
    if (voucherItemType == Common.voucherTypes.CommoditySKU) return 'SKU';                  
    if (voucherItemType == Common.voucherTypes.CommodityConversion) return '荷姿';                  
    if (voucherItemType == Common.voucherTypes.CommodityShelfNo) return '棚番号';                  
    if (voucherItemType == Common.voucherTypes.StockRelocationItem) return '在庫移動明細';                  
    if (voucherItemType == Common.voucherTypes.StockTransferItem) return '在庫振替明細';                  
    if (voucherItemType == Common.voucherTypes.StockTakingItem) return '棚卸処理明細';                  
    if (voucherItemType == Common.voucherTypes.PickingItem) return 'ピッキング明細';          
    if (voucherItemType == Common.voucherTypes.Component) return '構成品';                     
    if (voucherItemType == Common.voucherTypes.SalesOrder) return '受注伝票';          
    if (voucherItemType == Common.voucherTypes.PurchaseOrder) return '発注伝票';        
    if (voucherItemType == Common.voucherTypes.SalesDelivery) return '出荷伝票';          
    if (voucherItemType == Common.voucherTypes.PurchaseDelivery) return '入荷伝票';              
    if (voucherItemType == Common.voucherTypes.StockBalance) return '案件在庫';                   
  }

  

  mounted(){
 
    this.onVoucherNoChanged();
  }

  public getPropValue(item: any, index:number){
    //indexが1はじまり
    switch (index) {
      case 1: return (this.tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText1 : item.reserveText1;
      case 2: return (this.tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText2 : item.reserveText2;      
      case 3: return (this.tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText3 : item.reserveText3;
      case 4: return (this.tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText4 : item.reserveText4;
      case 5: return (this.tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText5 : item.reserveText5;
      case 6: return (this.tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText6 : item.reserveText6;                         
      case 7: return (this.tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveMemo1  :item.reserveMemo1;                
      case 8: return (this.tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveMemo2  :item.reserveMemo2;   
      case 9: return (this.tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveMemo3 : item.reserveMemo3;
      case 10: return (this.tenantSettings.usedTypeDetailReserveDate1 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatDate(item.commodity.reserveDate1) : this.$api.formatter.formatDate(item.reserveDate1);          
      case 11: return (this.tenantSettings.usedTypeDetailReserveDate2 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatDate(item.commodity.reserveDate2) : this.$api.formatter.formatDate(item.reserveDate2);    
      case 12: return (this.tenantSettings.usedTypeDetailReserveDate3 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatDate(item.commodity.reserveDate3) : this.$api.formatter.formatDate(item.reserveDate3);      
      case 13: return (this.tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatByList(item.commodity.reserveList1, 'category_41') : this.$api.formatter.formatByList(item.reserveList1, 'category_41');                            
      case 14: return (this.tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatByList(item.commodity.reserveList2, 'category_42') : this.$api.formatter.formatByList(item.reserveList2, 'category_42');        
      case 15: return (this.tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatByList(item.commodity.reserveList3, 'category_43') : this.$api.formatter.formatByList(item.reserveList3, 'category_43');                   
      default: return '';           
    }
  }
  public getPropValueIn(item: any, index:number){
    //indexが1はじまり
    switch (index) {
      case 1: return (this.tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText1 : item.reserveText1;
      case 2: return (this.tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText2 : item.reserveText2;      
      case 3: return (this.tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText3 : item.reserveText3;
      case 4: return (this.tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText4 : item.reserveText4;
      case 5: return (this.tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText5 : item.reserveText5;
      case 6: return (this.tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveText6 : item.reserveText6;                         
      case 7: return (this.tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveMemo1  :item.reserveMemo1;                
      case 8: return (this.tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveMemo2  :item.reserveMemo2;   
      case 9: return (this.tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.CommodityMemo) ? item.commodity.reserveMemo3 : item.reserveMemo3;
      case 10: return (this.tenantSettings.usedTypeDetailReserveDate1 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatDate(item.commodity.reserveDate1) : this.$api.formatter.formatDate(item.reserveDate1);          
      case 11: return (this.tenantSettings.usedTypeDetailReserveDate2 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatDate(item.commodity.reserveDate2) : this.$api.formatter.formatDate(item.reserveDate2);    
      case 12: return (this.tenantSettings.usedTypeDetailReserveDate3 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatDate(item.commodity.reserveDate3) : this.$api.formatter.formatDate(item.reserveDate3);      
      case 13: return (this.tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatByList(item.commodity.reserveList1, 'category_41') : this.$api.formatter.formatByList(item.reserveList1, 'category_41');                            
      case 14: return (this.tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatByList(item.commodity.reserveList2, 'category_42') : this.$api.formatter.formatByList(item.reserveList2, 'category_42');        
      case 15: return (this.tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.CommodityMemo) ? this.$api.formatter.formatByList(item.commodity.reserveList3, 'category_43') : this.$api.formatter.formatByList(item.reserveList3, 'category_43');                   
      default: return '';           
    }
  }

  public onPageChange(index: number){
    this.params.currentPage = index;
    this.isLoading = true;
    this.$api.execute(this.params).then(res =>{
        this.isLoading = false;
        this.items = (res as LoadResult).result;
        this.totalRows = (res as LoadResult).records;

        this.$emit('afterVoucherNoChanged'); // 明細読み込み後に親コンポーネント側の更新
    });

  }

  public params : Common.LoadQuery = null;
  public totalRows : Number = 0;
  @Watch('voucherNo')   
  public onVoucherNoChanged(){
    this.waitPendingLists().then(res2=>{
      if (this.voucherNo){
        this.isLoading = true;
        this.params = this.getQuery();
        this.params.perPage = 100; //最大100行
        this.params.loadAll = false;
        this.params.currentPage = 1;

        this.$api.execute(this.params).then(res =>{
          if(this.pendingCallbacks.length == 0)
          {
            this.isLoading = false;
            this.items = (res as LoadResult).result;
            this.totalRows = (res as LoadResult).records;

            this.$emit('afterVoucherNoChanged'); // 明細読み込み後に親コンポーネント側の更新
          }
          else
          {
            var resolve = this.pendingCallbacks.pop();
            resolve();
          }
        });
      } 
      else
      {
        if(this.pendingCallbacks.length == 0) this.isLoading = false;
        this.items = new Array();
         this.$emit('afterVoucherNoChanged'); // 明細読み込み後に親コンポーネント側の更新
      }
    });
  }
  public mergeItems(newItems:Array<any>){
      newItems.forEach(obj=>this.items.push(obj));
      return this.items;
  }
  pendingCallbacks = new Array<(value?:any)=>void>();
  
  public async waitPendingLists(){
    if(this.isLoading)
      return new Promise((resolve,reject) =>{
        this.pendingCallbacks.push(resolve);
      });
      else
        return Promise.resolve(true);
  }

  public getQuery(){

    if (this.voucherItemType == Common.voucherTypes.SalesOrderItem){
      const query = new Common.OrderItemQuery(Common.SalesPurchaseFlags.Sales);
      query.orderNo = this.voucherNo;      
      query.state = null;
      query.loadAll = true;
      query.partialInclude = true;      
      return query;
    }
    if (this.voucherItemType == Common.voucherTypes.SalesDeliveryItem){
      const query = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Sales);
      if (this.voucherType == Common.voucherTypes.SalesOrder)  query.orderItemNo = this.voucherNo;
      if (this.voucherType == Common.voucherTypes.SalesOrderItem)  query.orderItemNo = this.voucherNo;      
      if (this.voucherType == Common.voucherTypes.SalesDelivery)  query.deliveryNo = this.voucherNo;
      if (this.voucherType == Common.voucherTypes.SalesInvoice)  query.auditNo = this.voucherNo;      
      query.state = null;
      query.loadAll = true;
      query.partialInclude = true;
      return query;           
    }    
    if (this.voucherItemType == Common.voucherTypes.SalesCharge){
      const query = new Common.ChargeQuery(Common.SalesPurchaseFlags.Sales);
      query.deliveryNo = this.voucherNo; //deliveryNoに要変更
      query.state = null;
      query.loadAll = true;
      query.partialInclude = true;            
      return query;                
    }    
    if (this.voucherItemType == Common.voucherTypes.SalesChargeItem){
      const query = new Common.ChargeItemQuery();
      query.deliveryItemId = Number.parseInt(this.voucherNo); //deliveryNoに要変更
      query.loadAll = true;
      query.partialInclude = true;            
      return query;  
    }    
    if (this.voucherItemType == Common.voucherTypes.PurchaseOrderItem){
      const query = new Common.OrderItemQuery(Common.SalesPurchaseFlags.Purchase);
      if (this.voucherType == Common.voucherTypes.PurchaseOrder)  query.orderNo = this.voucherNo;
      if (this.voucherType == Common.voucherTypes.SalesOrder)  query.salesOrderItemNo = this.voucherNo;      
      if (this.voucherType == Common.voucherTypes.SalesOrderItem)  query.salesOrderItemNo = this.voucherNo;            
      query.state = null;
      query.loadAll = true;
      query.partialInclude = true;      
      return query;      
    }    
    if (this.voucherItemType == Common.voucherTypes.PurchaseDeliveryItem){
      const query = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Purchase);
      if (this.voucherType == Common.voucherTypes.PurchaseOrder)  query.orderItemNo = this.voucherNo;
      if (this.voucherType == Common.voucherTypes.PurchaseOrderItem)  query.orderItemNo = this.voucherNo;      
      if (this.voucherType == Common.voucherTypes.PurchaseDelivery)  query.deliveryNo = this.voucherNo;      
      if (this.voucherType == Common.voucherTypes.SalesOrder) query.salesOrderItemNo = this.voucherNo;      
      if (this.voucherType == Common.voucherTypes.SalesOrderItem) query.salesOrderItemNo = this.voucherNo;         
      query.state = null;
      query.loadAll = true;
      query.partialInclude = true;      
      return query;       
    }    
    if (this.voucherItemType == Common.voucherTypes.PurchaseCharge){
      const query = new Common.ChargeQuery(Common.SalesPurchaseFlags.Purchase);
      query.deliveryNo = this.voucherNo; //deliveryNoに要変更
      query.state = null;
      query.loadAll = true;
      query.partialInclude = true;            
      return query;                  
    }    
    if (this.voucherItemType == Common.voucherTypes.PurchaseChargeItem){
      const query = new Common.ChargeItemQuery();
      query.deliveryItemId = Number.parseInt(this.voucherNo); //deliveryNoに要変更
      query.loadAll = true;
      query.partialInclude = true;            
      return query;   
    }       

    //商品マスタのタブ
    if (this.voucherItemType == Common.voucherTypes.CommodityPrice){
      const query = new Common.PriceQuery();
      query.commodityCode = this.voucherNo;
      query.loadAll = true;
      return query;   
    }

    if (this.voucherItemType == Common.voucherTypes.CommoditySKU){
      const query = new Common.SKUQuery();
      query.commodityCode = this.voucherNo; 
      query.loadAll = true;
      return query;   
    }

    if (this.voucherItemType == Common.voucherTypes.CommodityConversion){
      const query = new Common.ConversionQuery();
      query.commodityCode = this.voucherNo; 
      query.loadAll = true;
      return query;   
    }
    if (this.voucherItemType == Common.voucherTypes.CommodityShelfNo){
      const query = new Common.ShelfNoQuery();
      query.commodityCode = this.voucherNo; 
      query.loadAll = true;
      return query;   
    }
    if (this.voucherItemType == Common.voucherTypes.StockRelocationItem){
      const query = new Common.StockRelocationItemQuery();
      query.stockRelocationNo = this.voucherNo; 
      query.state = null;
      query.loadAll = true;
      return query;         
    }
    if (this.voucherItemType == Common.voucherTypes.StockTakingItem){
      const query = new Common.StockTakingItemQuery();
      query.stockTakingNo = this.voucherNo;
      query.state = null;      
      query.loadAll = true;
      return query;         
    }    
    if (this.voucherItemType == Common.voucherTypes.PickingItem){
      const query = new Common.PickingItemQuery();
      query.pickingNo = this.voucherNo;  
      query.loadAll = true;
      return query;         
    }        
    if (this.voucherItemType == Common.voucherTypes.StockTransferItem){
      const query = new Common.StockTransferItemQuery();
      query.stockTransferNo = this.voucherNo; 
      query.state = null;      
      query.loadAll = true;
      return query;         
    }        
    if (this.voucherItemType == Common.voucherTypes.Component){
      const query = new Common.ComponentQuery();
      query.assemblyId = parseInt( this.voucherNo); 
      query.loadAll = true;
      return query;         
    }            
    if (this.voucherItemType == Common.voucherTypes.SalesOrder){
      const query = new Common.OrderQuery(Common.SalesPurchaseFlags.Sales);
      query.projectItemNo = this.voucherNo; 
      query.loadAll = true;
      query.state = null;
      return query;         
    }       
    if (this.voucherItemType == Common.voucherTypes.PurchaseOrder){
      const query = new Common.OrderQuery(Common.SalesPurchaseFlags.Purchase);
      query.projectItemNo = this.voucherNo; 
      query.loadAll = true;
      query.state = null;      
      return query;         
    }          
    if (this.voucherItemType == Common.voucherTypes.SalesDelivery){
      const query = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Sales);
      query.projectItemNo = this.voucherNo; 
      query.loadAll = true;
      query.state = null;      
      return query;         
    }     
    if (this.voucherItemType == Common.voucherTypes.PurchaseDelivery){
      const query = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Purchase);
      query.projectItemNo = this.voucherNo; 
      query.loadAll = true;
      query.state = null;      
      return query;         
    }      
    if (this.voucherItemType == Common.voucherTypes.StockBalance){
      const query = new Common.StockBalanceQuery();
      query.projectItemNo = this.voucherNo; 
      query.loadAll = true;
      return query;         
    }         
  }

  //明細ポップオーバー表示
  public popoverItemType : Common.voucherTypes;
  public popoverVisible :boolean = false;
  public popoverTarget : HTMLElement = null;
  public popoverVoucherNo:string = null;
  public showPopover(voucherNo:string, itemType: Common.voucherTypes,event :any) {

    //ポップオーバー表示
    if (this.popoverVisible){
      this.popoverTarget.onblur = null;      
      this.popoverVisible = false;
    }

    this.popoverItemType = itemType;
    this.popoverTarget = event.srcElement as HTMLElement;
    //イベント
    this.popoverTarget.onblur =this.onFocusOut;
    this.popoverVoucherNo = voucherNo;
    this.popoverVisible = true;

  }

  public onFocusOut(e:any){
    //cx_voucherItemsを見つける=>popoverの本体を見つける
    if (((this.$refs.popover as Vue).$children[0].$el as HTMLElement).parentNode.parentNode.parentNode.contains(e.relatedTarget)){
        (e.srcElement as HTMLElement).focus();//フォーカスバック
    } else {
      this.popoverTarget.onblur = null;
      this.popoverVisible = false;
    }
  }

  //追加・編集・削除機能

  public replaceItem(newItem:any){
    console.log(newItem.name);
    if (! newItem.initialSavedOn) return; //未保存の場合は置換えない

    var index = this.items.findIndex(value=>  this.comparer(value,newItem));
    if (index == -1) index = this.items.length; //存在しない場合は追加する
    this.$set(this.items, index, newItem);
  }

  public insertMode:boolean = false;  
  public showEditor:boolean = false;
  public editItem:any = null;

  public onAdd(){
    this.insertMode = true;
    this.editItem = null;
    this.showEditor = true;
  }

  public onEdit(item: any){
    this.editItem = item;
    this.insertMode = false;
    this.showEditor = true;
  }

  public async onDelete(){

      if (this.selectedItems.length == 0){
      this.$api.modal.show('無効な操作', '削除する行を選択してください。', true, null);
      return Promise.reject();        
      }
      var deletable = (obj:any) =>{
          //listViewから移植(若干簡略化)
          if (obj instanceof  Common.StateObject)
            //開始ステータスの場合だけ削除できる=>2020.3.3 haramoto フラグ化対応 
            return (this.$api.perms.getWorkflowState(obj.workflowCode, obj.workflowId, obj.workflowStateId).type & Common.StateTypes.EntryStatus)  == Common.StateTypes.EntryStatus;
          else if(obj instanceof Common.StateObject2)   
            return (obj as Common.StateObject2).isDeletable;
          else 
            return true;
        }
        
      if(this.selectedItems.filter(item =>deletable(item) == false).length > 0){
        this.$api.modal.show('無効な操作','ワークフローが進行している行が含まれるため削除できません。',true,null);
        return Promise.reject();  
      }

      return this.$api.modal.showDialog('確認メッセージ', this.selectedItems.length + '件のデータを本当に削除してよろしいですか?', false).then(async ()=>{
        
        for(let item of this.selectedItems){        
          await this.$api.remove(item);
          // var index = this.items.findIndex(value=> this.comparer(value,item));        
          // this.items.splice(index,1);
        }
        //明細番号が変わるのでリスト全体をリロードする必要がある
        this.onVoucherNoChanged();
        return Promise.resolve();
      });
  }  

}
</script>

<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_voucherItems{
  @extend .cx_vertical_fill;
  padding-top: 5px;
  padding-left: 30px;
  padding-right: 30px;    
  // padding-bottom: 15px;
  .cx_voucherItems_container{
    display: flex;
    flex-direction: column;
    flex:1;
    overflow-y: hidden;
  }
  &.cx_popover {
    padding-top: 5px;
    padding-left: 5px;
    padding-right: 5px;    
    padding-bottom: 5px;  
  }


  .grid {
    
  }
  .cx_link_item{
    margin-left :5px;
    margin-right :5px;    
  }

  ul.pagination{
    margin-bottom: unset;
    .page-link {
      line-height: 1.2;
    }
  }
}
.cx_header {
  display:flex;
  margin: 0 0 5px 0;    
  // min-height: 28.89px;
  .cx_spmode & {
    flex-direction: column;
  }
    .caption {
    display:flex;       
    height: 28.89px;
    align-items:center;    
    word-break: keep-all;
    }
    .menu{
      flex:1;
      display: flex;
      justify-content: flex-end;
      .cx_spmode & {
      overflow-x:auto;         
      justify-content: flex-start;         
      }
      .cx_button{
        font-size: 14px;
        margin-left:10px;
        min-width: 110px;
        .cx_spmode & {
          margin-left:unset;
          margin-right:10px;
        }              
        padding-top:3px;
        height: 28.89px;         
      }
        .cx_split_button {
          .cx_button{
            .cx_spmode & {
              margin-left:unset;
              margin-right:unset;         
            } 
          }
          .cx_split_button_container {
            .cx_spmode & {
              margin-left:unset;  
              margin-right:10px;        
            }    
          }
        }       
    }
}
.popover{
  max-width: 900px !important;
  background-color:#e2ebd2;  
  // max-height: 300px !important;

  .arrow::after {
    border-top-color:#e2ebd2;  
  }
}

</style>

